var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('ul',{staticClass:"tableList"},_vm._l((_vm.tableDate),function(item,index){return _c('li',{style:({ height: `${100 / _vm.tableDate.length}%` })},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }